export default __webpack_public_path__ + "static/media/l8.2c61a2ae.jpg";